export const testimonialsAPI = [
    {
        id: '00x1',
        title: 'Friendly staff, very helpful.',
        comment: 'Over the years my dentist has helped me overcome my fear of going to the dentist and fear of the pain. He is very patient, calming, takes time to explain things so I can understand them and has a sense of humor which helps me. I like my hygienist and the rest of my support staff.',
        user: {
            name: 'Lily Milton',
            occupation: 'Manager',
            img: '/assets/img/testimonials/p-1.jpg'
        }
    },
    {
        id: '00x2',
        title: 'Awesome!',
        comment: 'I brought in both of my children (6 and 4), the staff was so friendly, patient, and accommodating!! They were in different rooms to which I floated back and forth to. Each time I went to check on them they were happy and doing what was asked. My kids talked about how much they loved their hygienists.',
        user: {
            name: 'Daniel Palmer',
            occupation: 'Researcher',
            img: '/assets/img/testimonials/p-2.jpg'
        }
    },
    {
        id: '00x3',
        title: 'Keep up the great work!',
        comment: 'Thank you so much for your wonderful and professional dental care. My last dentist retired and I was nervous about selecting my future dental care professionals. After selecting Dental Clinic, I feel compelled to send you a note to let you know how great my experience was.',
        user: {
            name: 'George Turner',
            occupation: 'Businessman',
            img: '/assets/img/testimonials/p-3.jpg'
        }
    },
    {
        id: '00x4',
        title: 'Professional and friendly!',
        comment: 'I’ve been going to Dental Clinic for years and have always had top-notch care. My hygienist does a great job cleaning my teeth and my dentist is friendly and listens to any concerns I have. My teeth always feel spotless when I leave. Great experience. Friendly and attentive staff.',
        user: {
            name: 'Lisa Gill',
            occupation: 'Chemist',
            img: '/assets/img/testimonials/p-4.jpg'
        }
    },
]